// Where a guest (external magic-link account, `guest` claim) may go. Rules and
// callables enforce the real boundary server-side; this only keeps the UI
// coherent. Pure, so it is unit-testable: the router guard (./index.js) calls
// it with the target route and the guest's granted project ids, and sends the
// guest to the returned path, or lets the navigation through on null.
export function guestRedirect(to, grantedIds = []) {
  // Team-only pages (meta.teamOnly), such as the Claude/ChatGPT guide: never,
  // not even while the guest's project list is still loading.
  if (to.meta && to.meta.teamOnly) return "/projects";

  // Never let a guest into the editable Details tab, even for their own
  // project, nor into Eerder onderzoek (other clients' research).
  if (to.name === "Project Details" || to.name === "Project Earlier Research") {
    return `/project/${to.params.id}/chat`;
  }

  const alwaysAllowed = ["Projects", "Profile", "Guest Sign In"].includes(
    to.name
  );
  const inGrantedProject = to.params.id && grantedIds.includes(to.params.id);
  // If the guest's project set hasn't loaded yet (e.g. a hard deep-link
  // before setUser resolves), let Firestore rules be the gate rather than
  // bouncing to /projects.
  const idsUnknown = grantedIds.length === 0;
  if (!(alwaysAllowed || inGrantedProject || idsUnknown)) return "/projects";
  return null;
}
